import {
  ADMINISTRATORFORM_FETCHITEM_LOAD,
  ADMINISTRATORFORM_FETCHITEM_SUCCEED,
  ADMINISTRATORFORM_FETCHITEM_FAIL,
  ADMINISTRATORFORM_EDITFORM_CHANGE,
  ADMINISTRATORFORM_ENTER_RESET,
  ADMINISTRATORFORM_CREATEITEM_LOAD,
  ADMINISTRATORFORM_CREATEITEM_SUCCEED,
  ADMINISTRATORFORM_CREATEITEM_FAIL,
  ADMINISTRATORFORM_EDITITEM_LOAD,
  ADMINISTRATORFORM_EDITITEM_SUCCEED,
  ADMINISTRATORFORM_EDITITEM_FAIL,
  ADMINISTRATORFORM_DELETEITEM_LOAD,
  ADMINISTRATORFORM_DELETEITEM_SUCCEED,
  ADMINISTRATORFORM_DELETEITEM_FAIL,
} from '../constants/actionTypes'

export default (state = {}, action) => {
  switch (action.type) {
    case ADMINISTRATORFORM_FETCHITEM_LOAD:
      return { ...state, isFetchItemLoading: true, fetchItemError: null }
    case ADMINISTRATORFORM_FETCHITEM_SUCCEED:
      return { ...state, isFetchItemLoading: false, item: action.item }
    case ADMINISTRATORFORM_FETCHITEM_FAIL:
      return { ...state, isFetchItemLoading: false, fetchItemError: action.fetchItemError }
    case ADMINISTRATORFORM_ENTER_RESET:
      return {}
    case ADMINISTRATORFORM_EDITFORM_CHANGE:
      return { ...state, formFieldValues: { ...state.formFieldValues, ...action.field } }
    case ADMINISTRATORFORM_CREATEITEM_LOAD:
      return {
        ...state,
        isCreateItemLoading: true,
        isCreateItemSuccess: false,
        createItemError: null,
      }
    case ADMINISTRATORFORM_CREATEITEM_SUCCEED:
      return { ...state, isCreateItemLoading: false, isCreateItemSuccess: true }
    case ADMINISTRATORFORM_CREATEITEM_FAIL:
      return { ...state, isCreateItemLoading: false, createItemError: action.createItemError }
    case ADMINISTRATORFORM_EDITITEM_LOAD:
      return {
        ...state,
        isEditItemLoading: true,
        isEditItemSuccess: false,
        editItemError: null,
      }
    case ADMINISTRATORFORM_EDITITEM_SUCCEED:
      return { ...state, isEditItemLoading: false, isEditItemSuccess: true }
    case ADMINISTRATORFORM_EDITITEM_FAIL:
      return { ...state, isEditItemLoading: false, editItemError: action.editItemError }
    case ADMINISTRATORFORM_DELETEITEM_LOAD:
      return {
        ...state,
        isDeleteItemLoading: true,
        isDeleteItemSuccess: false,
        deleteItemError: null,
      }
    case ADMINISTRATORFORM_DELETEITEM_SUCCEED:
      return { ...state, isDeleteItemLoading: false, isDeleteItemSuccess: true }
    case ADMINISTRATORFORM_DELETEITEM_FAIL:
      return { ...state, isDeleteItemLoading: false, deleteItemError: action.deleteItemError }
    default:
      return state
  }
}
